"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var context = /*#__PURE__*/_react.default.createContext({
  animating: false,
  atBottom: true,
  atEnd: true,
  atTop: true,
  mode: 'bottom',
  sticky: true
});

context.displayName = 'ScrollToBottomStateContext';
var _default = context;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9TY3JvbGxUb0JvdHRvbS9TdGF0ZUNvbnRleHQuanMiXSwibmFtZXMiOlsiY29udGV4dCIsIlJlYWN0IiwiY3JlYXRlQ29udGV4dCIsImFuaW1hdGluZyIsImF0Qm90dG9tIiwiYXRFbmQiLCJhdFRvcCIsIm1vZGUiLCJzdGlja3kiLCJkaXNwbGF5TmFtZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBRUEsSUFBTUEsT0FBTyxnQkFBR0MsZUFBTUMsYUFBTixDQUFvQjtBQUNsQ0MsRUFBQUEsU0FBUyxFQUFFLEtBRHVCO0FBRWxDQyxFQUFBQSxRQUFRLEVBQUUsSUFGd0I7QUFHbENDLEVBQUFBLEtBQUssRUFBRSxJQUgyQjtBQUlsQ0MsRUFBQUEsS0FBSyxFQUFFLElBSjJCO0FBS2xDQyxFQUFBQSxJQUFJLEVBQUUsUUFMNEI7QUFNbENDLEVBQUFBLE1BQU0sRUFBRTtBQU4wQixDQUFwQixDQUFoQjs7QUFTQVIsT0FBTyxDQUFDUyxXQUFSLEdBQXNCLDRCQUF0QjtlQUVlVCxPIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuY29uc3QgY29udGV4dCA9IFJlYWN0LmNyZWF0ZUNvbnRleHQoe1xuICBhbmltYXRpbmc6IGZhbHNlLFxuICBhdEJvdHRvbTogdHJ1ZSxcbiAgYXRFbmQ6IHRydWUsXG4gIGF0VG9wOiB0cnVlLFxuICBtb2RlOiAnYm90dG9tJyxcbiAgc3RpY2t5OiB0cnVlXG59KTtcblxuY29udGV4dC5kaXNwbGF5TmFtZSA9ICdTY3JvbGxUb0JvdHRvbVN0YXRlQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGNvbnRleHQ7XG4iXX0=